import { environment } from '../environments/environment';

export const APP_CONST = environment.ENDPOINTS;
